<!-- loading state -->
<div
  *ngIf="
    loading &&
    ((activePanel === panel.key && refreshCurrentPanel) ||
      activePanel !== panel.key)
  "
>
  <va-custom-skeleton [customSkeletonConfig]="customSkeletonConfig">
  </va-custom-skeleton>
</div>
<div class="tree-container">
  <!-- loading tree without virtual scroll -->
  <ng-container *ngIf="!panel.useVirtualScroll">
    <div
      *ngIf="
        !loading || (activePanel == panel.key && !refreshCurrentPanel)
      "
      class="real-scroll-panel-is-tree"
    >
      <nz-tree
        class="facet-tree"
        [nzData]="facetData[panel.key]"
        nzCheckable
        nzMultiple
        [nzSelectedKeys]="cachedSelections[panel.key]"
        [nzCheckedKeys]="cachedSelections[panel.key]"
        (nzCheckBoxChange)="
          onHierarchyOptionChange(panel.key, $event)
        "
        (nzExpandChange)="onExpandChange($event, panel)"
        [nzTreeTemplate]="nzTreeTemplate"
        nzHideUnMatched
        [nzSearchValue]="
          facetCategorySearch[panel.key] &&
          facetCategorySearch[panel.key].trim().length >= 3
            ? facetCategorySearch[panel.key].trim()
            : ''
        "
      ></nz-tree>
    </div>
  </ng-container>
  <!-- loading tree with virtual scroll -->
  <ng-container *ngIf="panel.useVirtualScroll">
    <!-- <cdk-virtual-scroll-viewport
      *ngIf="
        !loading || (activePanel == panel.key && !refreshCurrentPanel)
      "
      itemSize="19"
      class="virtual-scroll"
    > -->
    <div
      *ngIf="
        !loading || (activePanel == panel.key && !refreshCurrentPanel)
      "
    >
    <!-- ==={{print(facetData)}}-----{{print(panel.key)}}=== -->
      <nz-tree
        class="facet-tree virtual-scroll"
        [nzData]="facetData[panel.key]"
        nzCheckable
        nzMultiple
        nzBlockNode
        nzVirtualHeight="280px"
        nzVirtualItemSize="30"
        nzVirtualMinBufferPx="300"
        nzVirtualMaxBufferPx="370"
        [nzSelectedKeys]="cachedSelections[panel.key]"
        [nzCheckedKeys]="cachedSelections[panel.key]"
        (nzCheckBoxChange)="
          onHierarchyOptionChange(panel.key, $event)
        "
        (nzExpandChange)="onExpandChange($event, panel)"
        [nzTreeTemplate]="nzTreeTemplate"
        nzHideUnMatched
        [nzSearchValue]="
          facetCategorySearch[panel.key] &&
          facetCategorySearch[panel.key].trim().length >= 3
            ? facetCategorySearch[panel.key].trim()
            : ''
        "
      ></nz-tree>
    </div>
    <!-- </cdk-virtual-scroll-viewport> -->
  </ng-container>

  <ng-template #nzTreeTemplate let-node>
    <div class="tree-option-container">
      <span
        title="{{ node['title'] }}"
        [ngClass]="
          node.isLeaf
            ? 'child-option'
            : 'level' + node.level.toString()
        "
        class="option"
        >{{ node["title"] }}</span
      >
      <span
        *ngIf="panel['showCount']"
        class="count"
        title="{{ node['title'] }}"
        >({{ node.origin["count"] }})</span
      >
    </div>
  </ng-template>
</div>